export default "__VITE_ASSET__C$VKxV7H__"